import React, { useState } from 'react';
import { Button, Row, Col, Container } from 'react-bootstrap';
import TemplateListPage from './TemplateListPage';
import AddNewTemplate from './AddNewTemplate';
import ViewTemplate from './ViewTemplate';
import PageTitle from '../../../components/PageTitle';

export const TemplateManagement = () => {
  const [showAddForm, setShowAddForm] = useState(false);

  return (
    <Container fluid className="template-management px-3 px-md-4 px-lg-5 py-4">
      <Row className="mb-2">
        <Col className="d-flex justify-content-end">
          <Button
            variant={showAddForm ? "outline-primary" : "outline-primary"}
            onClick={() => setShowAddForm(!showAddForm)}
            className="px-4"
          >
            {showAddForm ? (
              <>
                <i className="mdi mdi-format-list-bulleted me-1"></i> View Templates
              </>
            ) : (
              <>
                <i className="mdi mdi-format-list-bulleted me-1"></i> New Template
                
              </>
            )}
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="p-3 rounded shadow-sm">
            {showAddForm ? (
              <AddNewTemplate />
            ) : (
              <TemplateListPage />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};